/* 
* @Description: 描述
* @Author: D
* @Date: 2024-03-12 09:34
* @LastEditTime: 2024-06-20 17:21
* @LastEditors: D
* @FilePath: \admin\src\main.js
*/
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'

import 'element-plus/dist/index.css'
import 'normalize.css'
import './assets/examine.scss'
import './assets/layout.scss'
import './assets/btn.scss'
import './assets/darkStyle.scss'

import mitt from 'mitt' // 导入mitt
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { installDirectives } from './directives'

// 组件路径
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import elTable from '@/components/elTable.vue'



const app = createApp(App);
app.config.globalProperties.Bus = mitt()

// 全局组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.component('base-el-table', elTable) // 使用新的组件名注册


installDirectives(app)
app.use(ElementPlus, {
  locale: zhCn,
})
  .use(store)
  .use(router)
  .mount('#app')